// extracted by mini-css-extract-plugin
export default {"root":"bEeZ1_","slideMask":"xxdw6w"};